export default "__VITE_ASSET__BqcZo1Li__"